<script setup lang="ts">
import {
  OptionChild,
  OptionMain,
  OptionsGroupsChild,
  OptionsGroupsMain,
} from '~/lib/services/store/catalog/catalog.dtos'
import { OptionsGroupsType } from '~/lib/services/store/common.dto'

const props = defineProps<{
  optionsGroup: OptionsGroupsMain | OptionsGroupsChild
}>()

const isCheckboxOption = (option: OptionMain | OptionChild) => {
  return option.max === 1 && option.min === 0
}

const isAddDisabled = computed(() => {
  let optionsQty = 0
  availableOptions.value.forEach((option: OptionMain | OptionChild) => {
    optionsQty += option.qty
  })
  return optionsQty >= props.optionsGroup.max
})

const availableOptions = computed(() => props.optionsGroup.options.filter(opt => opt.available))
</script>

<template>
  <section>
    <h3 class="my-4 text-lg font-bold md:text-2xl">
      {{ optionsGroup.title }}
    </h3>
    <div v-for="option in availableOptions" :key="option.identifier">
      <!-- Force COMMENT optionsGroups display as quantity -->
      <template
        v-if="isCheckboxOption(option) && optionsGroup.type !== OptionsGroupsType.CONDIMENT"
      >
        <CheckboxRow
          v-model:checked-option="option.qty"
          :disable-add="isAddDisabled"
          :option="option"
        />
      </template>
      <template v-else>
        <QuantitySelectorRow
          v-model:count-row="option.qty"
          :disable-add="isAddDisabled"
          :option="option"
        />
      </template>
    </div>
  </section>
</template>
